interface IConversationMessageValues {
	timeStamp: Date;
	text: string;
	myMessage: boolean;
	status?: "pending" | "failed";
}

export class ConveresationMessage implements IConversationMessageValues {
	timeStamp: Date;
	text: string;
	myMessage: boolean;
	status?: "pending" | "failed";

	constructor(values: Partial<IConversationMessageValues>) {
		this.timeStamp = new Date(values.timeStamp ?? 0);
		this.text = values.text ?? "";
		this.myMessage = values.myMessage ?? false;
		this.status = values.status;
	}
}
